<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoiceStatementDetail.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('invoiceStatementDetail.pageTitle'),
						active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('invoiceStatementDetail.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('invoiceStatementDetail.fromYear')
                      }}</label>
                      <input type="number" class="form-control" v-model.number="model.from_year">
                      <div class="validate" v-if="errors.has('from_year')">
                        {{ errors.first('from_year') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('invoiceStatementDetail.toYear')
                      }}</label>
                      <input type="number" class="form-control" v-model.number="model.to_year">
                      <div class="validate" v-if="errors.has('to_year')">
                        {{ errors.first('to_year') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('invoiceStatementDetail.month')
                      }}</label>
                      <select class="form-control" v-model.number="model.month">
                        <option 
                          v-for="month in 12"
                          :key="month"
                          :value="month">{{ getMonthName(month) }}</option>
                      </select>
                      <div class="validate" v-if="errors.has('month')">
                        {{ errors.first('month') }}
                      </div>
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf text-red"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('payToVendor.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'incomeStatement',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: null,
      errors: new Errors(),
      vendors: [],
      model: {
        from_year: parseInt(moment().add(-1, 'years').format('YYYY')),
        to_year: parseInt(moment().format('YYYY')),
        month: parseInt(moment().format('M')),
      }
    }
  },
  computed: {
    getMonthName: vm => monthNumb => {
      return moment(monthNumb, 'MM').format('MMMM')
    }
  },
  methods: {
		...mapActions('report/finance', ['incomeStatementDetail']),
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.incomeStatementDetail(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/finance/incomeStatementDetailExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
